import { create, v } from '@dojo/framework/core/vdom';
import theme from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/icon.m.css';
import baseCss from '../css/base.m.css';
const factory = create({ theme }).properties();
export const Icon = factory(function Icon({ id, properties, middleware: { theme } }) {
    const { aria = {
        hidden: 'true'
    }, faname, fapre, altText, spin, rotate, size, xqa, onOver, onOut, onBlur, onFocus } = properties();
    const classes = theme.classes(css);
    const sizeClass = size ? `fa-${size}` : undefined;
    const spinning = spin ? 'fa-spin' : undefined;
    const rotated = rotate ? `fa-rotate-${rotate}` : undefined;
    return v('i', {
        key: id,
        xqa,
        role: 'img',
        classes: [classes.root, fapre ? fapre : 'fas', `fa-${faname}`, spinning, rotated, sizeClass].filter((v) => Boolean(v)),
        onpointerenter: () => onOver && onOver(),
        onpointerleave: () => onOut && onOut(),
        onblur: () => onBlur && onBlur(),
        onfocus: () => onFocus && onFocus(),
        ...formatAriaProperties(aria)
    }, [altText ? v('span', { classes: [baseCss.visuallyHidden] }, [altText]) : null]);
});
export default Icon;
